import React, { Component } from 'react';
import Select from 'react-select';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Row,
  Col,
} from 'reactstrap';
import { toast } from 'react-toastify';
import { bulkAssignVisionRequests, fetchCaseCount } from '../../services/api/cashless-vision';

class BulkAssignModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalVisible: false,
      claimedByUser: null,
      caseCount: null,
      caseCountLoading: false,
      assignCount: '',
      assignToUser: null,
      loading: false,
    };
  }

  toggleModal = () => {
    this.setState((prev) => ({
      modalVisible: !prev.modalVisible,
      claimedByUser: null,
      caseCount: null,
      assignCount: '',
      assignToUser: null,
    }));
  };

  handleClaimedByChange = async (option) => {
    this.setState({ claimedByUser: option, caseCount: null, assignCount: '', assignToUser: null });
    if (!option) return;

    this.setState({ caseCountLoading: true });
    try {
      const response = await fetchCaseCount(option.value);
      this.setState({ caseCount: response.data.caseCount });
    } catch (err) {
      console.error(err);
      toast.error('Failed to fetch case count');
    } finally {
      this.setState({ caseCountLoading: false });
    }
  };

  handleAssignCountChange = (e) => {
    const val = e.target.value;
    if (val === '') {
      this.setState({ assignCount: '' });
      return;
    }
    const num = parseInt(val, 10);
    const { caseCount } = this.state;
    if (!isNaN(num) && num >= 0 && (caseCount === null || num <= caseCount)) {
      this.setState({ assignCount: num });
    }
  };

  handleAssign = async () => {
    const { claimedByUser, assignCount, assignToUser } = this.state;
    const { onComplete } = this.props;

    if (!claimedByUser) {
      toast.warning('Please select a Claimed By user');
      return;
    }
    if (assignCount === '' || assignCount <= 0) {
      toast.warning('Please enter a valid count');
      return;
    }
    if (!assignToUser) {
      toast.warning('Please select an Assign To user');
      return;
    }

    this.setState({ loading: true });
    try {
      await bulkAssignVisionRequests(claimedByUser.value, assignToUser.value, assignCount);
      toast.success(`${assignCount} cases assigned to ${assignToUser.label}`);
      this.setState({ modalVisible: false, claimedByUser: null, caseCount: null, assignCount: '', assignToUser: null });
      if (onComplete) onComplete();
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to bulk assign requests');
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const {
      modalVisible,
      claimedByUser,
      caseCount,
      caseCountLoading,
      assignCount,
      assignToUser,
      loading,
    } = this.state;

    const users = this.props.users || [];

    // Exclude the selected "Claimed By" user from "Assign To" options
    const assignToOptions = claimedByUser
      ? users.filter((u) => u.value !== claimedByUser.value)
      : users;

    const labelStyle = { fontFamily: 'Inter, sans-serif', marginBottom: 0 };
    const infoBoxStyle = {
      padding: '8px 12px',
      backgroundColor: 'rgba(113, 79, 255, 0.05)',
      borderRadius: '8px',
      fontFamily: 'Inter, sans-serif',
      fontSize: '14px',
      color: '#714FFF',
      fontWeight: '600',
      minHeight: '38px',
      display: 'flex',
      alignItems: 'center',
    };

    return (
      <div>
        <button
          type="button"
          style={{
            backgroundColor: '#714FFF',
            color: '#FFFFFF',
            border: 'none',
            borderRadius: '5px',
            padding: '8px 12px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: '600',
            fontSize: '12px',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
          onClick={this.toggleModal}
        >
          Bulk Assign
        </button>

        <Modal centered isOpen={modalVisible} toggle={this.toggleModal}>
          <ModalHeader
            toggle={this.toggleModal}
            style={{ borderBottom: '1px solid #E0E0E0' }}
          >
            <span
              style={{
                color: '#714FFF',
                fontSize: '16px',
                fontWeight: '600',
                fontFamily: 'Inter, sans-serif',
              }}
            >
              Bulk Assign
            </span>
          </ModalHeader>

          <ModalBody>
            {/* Claimed By */}
            <FormGroup>
              <Row className="align-items-center">
                <Col className="col-4">
                  <Label style={labelStyle}>
                    Current Claimed By:<span style={{ color: 'red' }}>*</span>
                  </Label>
                </Col>
                <Col>
                  <Select
                    isSearchable
                    isClearable
                    value={claimedByUser}
                    onChange={this.handleClaimedByChange}
                    options={users}
                    isLoading={false}
                    placeholder="Select ops user"
                  />
                </Col>
              </Row>
            </FormGroup>

            {/* Total Case Count */}
            <FormGroup>
              <Row className="align-items-center">
                <Col className="col-4">
                  <Label style={labelStyle}>Total Case Count:</Label>
                </Col>
                <Col>
                  <div style={infoBoxStyle}>
                    {caseCountLoading ? 'Loading...' : caseCount !== null ? caseCount : '—'}
                  </div>
                </Col>
              </Row>
            </FormGroup>

            {/* Assign Count */}
            <FormGroup>
              <Row className="align-items-center">
                <Col className="col-4">
                  <Label style={labelStyle}>
                    Assign Count:<span style={{ color: 'red' }}>*</span>
                  </Label>
                </Col>
                <Col>
                  <input
                    type="number"
                    className="form-control"
                    value={assignCount}
                    onChange={this.handleAssignCountChange}
                    placeholder={caseCount !== null ? `Max  ${caseCount}` : 'Select Claimed By first'}
                    min={1}
                    max={caseCount !== null ? caseCount : undefined}
                    disabled={caseCount === null}
                  />
                </Col>
              </Row>
            </FormGroup>

            {/* Assign To */}
            <FormGroup>
              <Row className="align-items-center">
                <Col className="col-4">
                  <Label style={labelStyle}>
                    Assign To:<span style={{ color: 'red' }}>*</span>
                  </Label>
                </Col>
                <Col>
                  <Select
                    isSearchable
                    isClearable
                    value={assignToUser}
                    onChange={(option) => this.setState({ assignToUser: option })}
                    options={assignToOptions}
                    isLoading={false}
                    isDisabled={!claimedByUser}
                    placeholder="Select ops user"
                  />
                </Col>
              </Row>
            </FormGroup>
          </ModalBody>

          <ModalFooter>
            <Button
              color="secondary"
              outline
              onClick={this.toggleModal}
              style={{ fontFamily: 'Inter, sans-serif', borderRadius: '8px' }}
            >
              Cancel
            </Button>
            <Button
              style={{
                backgroundColor: '#714FFF',
                border: 'none',
                fontWeight: '600',
                borderRadius: '8px',
                fontFamily: 'Inter, sans-serif',
              }}
              onClick={this.handleAssign}
              disabled={loading || !claimedByUser || !assignToUser || assignCount === '' || assignCount <= 0}
            >
              {loading ? 'Assigning...' : 'Assign'}
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default BulkAssignModal;
